import React from 'react';
import Calender from './Calender';
import Toggle from './../Toggle';

class PopupCalendar extends React.Component {
  handleDateApply = showHide => (fromDate, toDate) => {
    const { changeDate } = this.props;

    changeDate(fromDate, toDate);
    showHide(false);
  };

  renderAction = toggle => {
    return (
      <a
        href="#"
        className="btn btn-cus-nomal bg-b-color-3 ml-5"
        onClick={toggle}
      >
        <i className="icon-calendar" />
      </a>
    );
  };

  renderPopup = (showHide, isShow) => {
    const { startDate, endDate, condition } = this.props;
    return (
      isShow && (
        <Calender
          parentRef={this.buttonCalendar}
          startDate={startDate}
          endDate={endDate}
          handleDateApply={this.handleDateApply(showHide)}
          condition={condition}
        />
      )
    );
  };

  render() {
    return (
      <div style={{ position: 'relative', width: '100%', textAlign: 'right' }}>
        <div
          className="d-flex float-right Calendar-right"
          ref={c => (this.buttonCalendar = c)}
        >
          <Toggle
            renderAction={this.renderAction}
            renderPopup={this.renderPopup}
          />
        </div>
      </div>
    );
  }
}

export default PopupCalendar;
